<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Department" subTitle="Forms" />

    <ListDepartment />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListDepartment from "@/components/Pages/Master/Department/ListDepartment.vue";

export default defineComponent({
  name: "ListDepartmentPage",
  components: {
    PageTitle,
    ListDepartment,
  },
});
</script>
